import { render, staticRenderFns } from "./ExternalAccessProjectDetailPage.vue?vue&type=template&id=1230995c&"
import script from "./ExternalAccessProjectDetailPage.vue?vue&type=script&lang=ts&"
export * from "./ExternalAccessProjectDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports